import React, { useEffect } from 'react';

import CornerCloseButton from '../../../../shared/CornerCloseButton/CornerCloseButton';
import AdminModalButton from '../../../buttons/AdminModalButton/AdminModalButton';

import './EditModalShell.css';

const EditModalShell = ({
  formId = 'modal-form',
  children,
  onClose,
  onSubmit,
  title,
  mode,
  itemLabel,
  itemSublabel,
  isLoading,
  isSubmitDisabled,
  className,
}) => {
  const editModalShellClassNames = ['edit-modal-shell', className].join(' ');

  useEffect(() => {
    const handleKeyDown = (e) =>
      !isLoading && e.key === 'Escape' ? onClose() : null;

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose, isLoading]);

  return (
    <div className='edit-modal-shell-backdrop'>
      <div className={editModalShellClassNames}>
        <div className='modal-shell-top-container'>
          <CornerCloseButton onClick={onClose} disabled={isLoading} />
        </div>
        <div className='modal-shell-content-container'>
          <div className='edit-title-container'>
            <span className='edit-title'>
              {title || `${mode === 'edit' ? 'Edit' : 'Add'} ${itemLabel}`}
            </span>
            <span className='edit-rates-subtitle'>
              {itemSublabel && `for ${itemSublabel}`}
            </span>
          </div>
          <form
            id={formId}
            action=''
            onSubmit={onSubmit}
            autoComplete='off'
            className='edit-form'
          >
            {children}
          </form>
        </div>
        <div className='modal-shell-bottom-container'>
          <div className='edit-buttons-container'>
            <AdminModalButton
              type='submit'
              form={formId}
              disabled={isLoading || isSubmitDisabled}
            >
              <span>
                {`${mode === 'add' ? 'Add' : 'Edit'}`}
                <span className='edit-modal-shell-btn-item-label'>
                  {` ${itemLabel}`}
                </span>
              </span>
            </AdminModalButton>
            <AdminModalButton
              type='button'
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </AdminModalButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditModalShell;
